import React from 'react';
import './SelectionModeButton.css';

export default ({ singleSelection, onClick }) => (
  <button
    className="SelectionModeButton"
    onClick={() => onClick && onClick(singleSelection)}
  >
    <span className={singleSelection ? 'fontawesome-user' : 'fontawesome-group'} />
  </button>
);



// WEBPACK FOOTER //
// ./src/components/SelectionModeButton/SelectionModeButton.jsx